import * as React from 'react'

import { Panel, PanelParentContext } from './Panel'

// returns the containing panel if there is one

export function usePanel() {
  const panel = React.useContext<Panel>(PanelParentContext);
  return panel
}